import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  h1: () => i18n.t(i18nKeys.supplyAcquisitionMethodSelector__h1),
  shipToMeText: () =>
    i18n.t(i18nKeys.supplyAcquisitionMethodSelector__shipToMeText),
  shipToMeButton: () =>
    i18n.t(i18nKeys.supplyAcquisitionMethodSelector__shipToMeButton),
  instructionOne: () =>
    i18n.t(i18nKeys.supplyAcquisitionMethodSelector__instructionOne),
  instructionTwo: () =>
    i18n.t(i18nKeys.supplyAcquisitionMethodSelector__instructionTwo),
  pickUpText: () =>
    i18n.t(i18nKeys.supplyAcquisitionMethodSelector__pickUpText),
  pickUpButton: () =>
    i18n.t(i18nKeys.supplyAcquisitionMethodSelector__pickUpButton),
  instructionThree: () =>
    i18n.t(i18nKeys.supplyAcquisitionMethodSelector__instructionThree),
  or: () => i18n.t(i18nKeys.common__or),
}
